import { put, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import ticketServices from './services';
import ticketActions from './actions';
import ticketTypes from './types';

function* getTicketsList(action) {
	try {
		let response = yield sagaCallService(
			ticketServices.list,
			action,
			action.payload
		);
		yield put(ticketActions.getListSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, ticketActions.getListFailure);
	}
}

function* getTicketById(action) {
	try {
		let response = yield sagaCallService(
			ticketServices.index,
			action,
			action.payload
		);
		yield put(ticketActions.getIndexSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, ticketActions.getIndexFailure);
	}
}

function* createTicketRequest(action) {
	try {
		let response = yield sagaCallService(
			ticketServices.create,
			action,
			action.payload
		);
		yield put(ticketActions.createSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, ticketActions.createFailure);
	}
}

function* getTicketComment(action) {
	try {
		let response = yield sagaCallService(
			ticketServices.comment,
			action,
			action.payload
		);
		yield put(ticketActions.ticketCommentSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, ticketActions.ticketCommentFailure);
	}
}

function* getTicketLogs(action) {
	try {
		let response = yield sagaCallService(
			ticketServices.log,
			action,
			action.payload
		);
		yield put(ticketActions.ticketLogsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, ticketActions.ticketLogsFailure);
	}
}

function* getSupportProblem(action) {
	try {
		let response = yield sagaCallService(
			ticketServices.support_ticket,
			action,
			action.payload
		);
		yield put(ticketActions.supportTicketSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, ticketActions.supportTicketFailure);
	}
}

const ticketSagas = [
	takeLatest(ticketTypes.LIST.REQUEST, getTicketsList),
	takeLatest(ticketTypes.INDEX.REQUEST, getTicketById),
	takeLatest(ticketTypes.CREATE.REQUEST, createTicketRequest),
	takeLatest(ticketTypes.COMMENT.REQUEST, getTicketComment),
	takeLatest(ticketTypes.LOG.REQUEST, getTicketLogs),
	takeLatest(ticketTypes.SUPPORT_PROBLEM.REQUEST, getSupportProblem),
];

export default ticketSagas;
